
<div class="container  pt-5">
    <div class="row">
      <div class="col-12 p-0">
        <div class="col-12 ">
          <div class="card p-2 bg-light">
            <nav class="navbar navbar-light bg-light">
              <div class="container ">
                <a class="navbar-brand">Local Connects</a>
                <form class="d-flex">
                  <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search" (keyup)="applyFilter($event)"  #input>
                </form>
              </div>
            </nav>
          </div>

          <div class="card">
          <div class="mat-elevation-z8  overflow">
            <table mat-table [dataSource]="dataSource" matSort>
          
        
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>  Name </th>
                <td mat-cell *matCellDef="let row"> {{row.firstName }} {{row.lastName}}</td>
              </ng-container>
        
              <ng-container matColumnDef="street">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email </th>
                <td mat-cell *matCellDef="let row"> {{row.email}} </td>
              </ng-container>
    
              <ng-container matColumnDef="phone">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone </th>
                <td mat-cell *matCellDef="let row"> {{row.phone}} </td>
              </ng-container>
               <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                <td mat-cell *matCellDef="let row"> {{row.email}} </td>
              </ng-container>
            
          
              <ng-container matColumnDef="reason">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Reason </th>
                <td mat-cell *matCellDef="let row"> {{row.reason}} </td>
              </ng-container>
        
              <ng-container matColumnDef="previousState">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Previous  </th>
                <td mat-cell *matCellDef="let row"> {{row.previousChurch}} </td>
              </ng-container>
        
               <ng-container matColumnDef="currentState">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Current</th>
                <td mat-cell *matCellDef="let row"> {{row.currentChurch}} </td>
              </ng-container>
        
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
            <td mat-cell *matCellDef="let row"> {{row.date}} </td>
          </ng-container>
        
    
        
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
              </tr>
            </table>
          
          
           
          </div>
          <mat-paginator [pageSizeOptions]="[15, 25]" aria-label="Select page of local connects"></mat-paginator>
        </div>
        </div>
      </div>
    </div>
  </div>